/* tslint:disable */
/* eslint-disable */
export enum PosTerminalModelEnum {
  Mini = 'Mini',
  Flex = 'Flex'
}
